<template>
  <v-container class="pt-0" v-if="department" fluid>
    <v-row>
      <v-col
        :class="$vuetify.breakpoint.xsOnly ? 'background-color-white' : ''"
        cols="12"
        md="7"
        lg="8"
        xl="9"
      >
        <Title
          :src="department.src"
          :sub="getCategory(department).name"
          :text="department.name"
        />
        <RouteTo
          v-if="department.sub_categories"
          :textContent="department.name"
        />
        <RouteBack v-else />
      </v-col>
      <v-col cols="12" md="5" lg="4" xl="3">
        <Sort />
      </v-col>
    </v-row>
    <SurgeonGeneralsWarning
      v-if="department.tobacco_warning"
      :text="getCategory(department).tobacco_warning"
    />
    <Loader :loaded="categoryLoaded" :marginTop="20" />
    <v-row
      class="background-color-white mb-0 mb-sm-6 mr-sm-0 px-3 px-sm-6"
      ref="ref"
    >
      <v-col
        v-for="(product, index) in products"
        class="position-relative"
        :key="index"
        cols="6"
        md="4"
        xl="3"
      >
        <Product
          :product="product"
          :size="$vuetify.breakpoint.xsOnly ? 'xs' : 'md'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import throttle from "lodash.throttle";
import Loader from "@/components/UI/Loader.vue";
import Product from "@/components/Product/index.vue";
import RouteBack from "@/components/UI/RouteBack.vue";
import RouteTo from "@/components/UI/RouteTo.vue";
import Sort from "@/components/UI/Sort.vue";
import SurgeonGeneralsWarning from "@/components/UI/SurgeonGeneralsWarning.vue";
import Title from "@/components/UI/Title.vue";

export default {
  name: "Category",
  components: {
    Loader,
    Product,
    RouteBack,
    RouteTo,
    Sort,
    SurgeonGeneralsWarning,
    Title,
  },
  computed: {
    ...mapGetters("category", {
      categoryLoaded: "loaded",
    }),
    ...mapState({
      departments: (state) => state.departments.data,
      products: (state) => state.category.products,
    }),
    department() {
      // need this because you can get to Category without going through (and loading in Vuex) a Department
      return (
        this.departments &&
        this.departments.length &&
        this.departments.find(this.findDepartment)
      );
    },
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkIfNeedMoreProducts() {
      const pixelsFromBottomToMakeAnotherRequest = 890;
      const scrollHeight = document.body.clientHeight;
      const scrollPos = window.innerHeight + window.scrollY;
      const timeToFetch =
        (scrollHeight - pixelsFromBottomToMakeAnotherRequest >= scrollPos) /
          scrollHeight ===
        0;
      if (timeToFetch) {
        this.$store.commit("category/UPDATE_PAGE");
        this.$store.dispatch("category/fetch", this.$route.params.categoryId);
      }
    },
    findDepartment(department) {
      return department.category_id === this.$route.params.departmentId;
    },
    getCategory(department) {
      const noDepartment = {
        name: "",
        tobacco_warning: department.tobacco_warning,
      };
      return department.sub_categories
        ? department.sub_categories.find((category) => {
            return category.category_id === this.$route.params.categoryId;
          })
        : noDepartment;
    },
    handleScroll: throttle(function () {
      this.checkIfNeedMoreProducts();
    }, 300),
  },
  watch: {
    "$route.params.categoryId": {
      handler: function (categoryId) {
        this.$store.dispatch("category/restartFetch", categoryId);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
